import styled from "styled-components";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  min-height: calc(100vh - 170px);
`;

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const HistoryBox = styled.div`
  border-radius: 16px;
  background: #F7F7F7;
  padding: 16px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
`;

export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 6px;
`;

export const View = styled.p`
  color: #999;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */

  span{
    color: #E39401;
  }
`;

export const Amount = styled.p`
  color: #E39401;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
`;

export const Date = styled.p`
  color: #1C1C1C;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 48px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 340px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
  color: #979797;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  margin-bottom: 24px;
  width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 350px) {
    gap: 4px;
  }
`

export const Link = styled.p`
  overflow: hidden;
  color: var(--Text-Primary, #1C1C1C);
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  word-break: break-all !important;

  flex: 1;
`

export const EmptyHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  flex: 1;

  border-radius: 16px;
  border: 1px solid #CCC;
  background: #FFF;
  padding: 12px 16px;

  @media screen and (max-width: 360px) {
  padding: 10px 4px;
  }
`

export const ShareButton = styled(AntButton)`
  height: 50px;
  font-size: 14px;
`

export const TNCBtn = styled(AntButton)`
  margin: 30px 0 16px;
  height: 50px;
`